module.exports = __webpack_public_path__ + "img/login_logo_text@2x.e4f7230e.png";